import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ReflectionHelper  {
    _originalTypeClassName = "zERP.BO.ReflectionHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ReflectionHelper.translate = translateService;
}
this.ReflectionHelperKey = null;
this._key = this.ReflectionHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _ReflectionHelperKey:any;
get ReflectionHelperKey(): any {
    return this._ReflectionHelperKey;
  }
set ReflectionHelperKey(value: any) {
    this._ReflectionHelperKey = value;
    this._key = value;
  }

static GetTypeName(instance: any): any{let typeToCheck = CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
if (Joove.Common.stringEndsWith(typeToCheck, "Proxy")) {typeToCheck = typeToCheck?.substr(0, Joove.Common.safeNumber(typeToCheck?.length) - Joove.Common.safeNumber(5));}
return typeToCheck;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ReflectionHelperKey == null || $this.ReflectionHelperKey == 0;
            }


}